import { SignupFlowSlug, flowPages } from "../constants";
import { useSignupFlowErrorStore } from "../hooks/useSignUpFlowErrorStore";
import { useSignupFlowStore } from "../hooks/useSignUpFlowStore";
import {
  findFirstIncompletePage,
} from "../../../shared/findFirstIncompletePage";
import { inABTestGroupFromSingleton } from "../featureFlags";
import {
  getFlowNavigationContextFromStore,
} from "../navigation/getFlowNavigationContextFromStore";
import { isPageAccessible } from "../navigation/isPageAccessible";

import { getRequiredFieldsForSlug } from "./validateSignUpField";
import { getCriticalFieldsForSlug } from "./criticalFieldsBySlug";

interface FindFirstIncompleteOptions {
  criticalOnly?: boolean;
}

export function findFirstIncompleteSignupPage(
  beforeSlug?: SignupFlowSlug,
  options: FindFirstIncompleteOptions = {},
): SignupFlowSlug | null {
  const { validatedFields } = useSignupFlowErrorStore.getState();
  const navigationContext = getFlowNavigationContextFromStore();
  let slugs = flowPages.map((p) => p.slug);

  if (beforeSlug) {
    const idx = slugs.indexOf(beforeSlug);
    if (idx !== -1) {
      slugs = slugs.slice(0, idx);
    }
  }

  slugs = slugs.filter((slug) => isPageAccessible(slug, navigationContext));

  const resolveFields = (slug: SignupFlowSlug) => {
    if (options.criticalOnly) {
      const { cats } = useSignupFlowStore.getState();
      return getCriticalFieldsForSlug(slug, cats, {
        inABTestGroup: inABTestGroupFromSingleton,
      });
    }
    return getRequiredFieldsForSlug(slug, {
      inABTestGroup: inABTestGroupFromSingleton,
    });
  };

  return findFirstIncompletePage({
    slugs,
    getRequiredFieldsForSlug: resolveFields,
    validatedFields,
  });
}
